import React, { useState } from 'react'
import Modal from 'react-modal'
import { Well, Grid, Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import useSWR from '../../hooks/useSWR'
import { getModalStyles } from '../../common/utils'
import { swalError, swalSuccess } from '../../common/components/Swaler'
import { inviteCarrier } from './actions'

const InviteCarrierModal = ({ closeModal }) => {
  const [input, setInput] = useState({})

  const locks = useSelector((state) => state.collectionData.locks.filter((l) => !l.isCarrierDoor))
  const { data, mutate } = useSWR('/subject/admin/drivers/local')

  const drivers = data && data.map((d) => ({ ...d, locks: locks.filter((l) => d.locks.includes(l._id)).map((l) => l.custom_name) }))

  const send = () => {
    if (!input.driverPhone) return swalError('Vänligen fyll i telefonnummer')
    if (!input.carrierName) return swalError('Vänligen fyll i chaufförens företag')

    inviteCarrier(input)
      .then((t) => {
        mutate(data.concat({ _id: Math.random(), name: 'Chaufför', locks: locks.map((l) => l._id), carrierName: input.carrierName }))
        console.log(t)
        closeModal()
        swalSuccess('Chaufför inbjuden', t.data.message, 'Stäng')
        return t
      })
      .catch((e) => {
        swalError(e.response.data.message)
      })
  }

  return (
    <div>
      <Modal ariaHideApp={false} isOpen={true} onRequestClose={() => closeModal()} style={getModalStyles()}>
        <div className="qCloseButton" onClick={() => closeModal()}>
          Stäng
        </div>

        <Grid fluid>
          <Row>
            <Col lg={12} xs={12} style={{ textAlign: 'center' }}>
              <h2>Lokala chaufförer</h2>
            </Col>
          </Row>

          <Row>
            <Col {...window.fullCol}>
              <Well>
                <p>Den här funktionen är till för att ni själva ska kunna lägga till en lokal chaufför som kan komma och lämna eller hämta gods från ert leveransutrymme.</p>
                <p> Det kan till exempel vara den lokala smeden eller om en underentreprenör som har en egen bil och kommer förbi med material någon gång varje vecka.</p>

                <p>OBS! Denna funktion ska inte användas för att lägga till chaufförer från större transportörer som Schenker, Postnord osv. Behöver ni hjälp med dessa så kontakta Qlocx.</p>
              </Well>
            </Col>

            <Col {...window.fullCol}>
              <br />
              <br />
            </Col>

            <Col {...window.fullCol}>
              <input
                type="text"
                onChange={(e) => setInput({ ...input, driverPhone: e.target.value })}
                placeholder="Fyll i telefonnummer till chaufför"
                style={{ border: 'none', borderBottom: '2px solid #246d6e', width: '50%', textAlign: 'center', fontSize: 14, marginLeft: '25%' }}
              />
            </Col>

            <Col {...window.fullCol}>
              <br />
              <br />
            </Col>

            <Col {...window.fullCol}>
              <input type="text" onChange={(e) => setInput({ ...input, carrierName: e.target.value })} placeholder="Fyll i chaufförens företag" style={{ border: 'none', borderBottom: '2px solid #246d6e', width: '50%', textAlign: 'center', fontSize: 14, marginLeft: '25%' }} />
            </Col>
            <Col {...window.fullCol}>
              <br />
              <br />
              <br />
              <br />
              <br />
            </Col>
            <Col {...window.fullCol}>
              <div className="qSaveButton" onClick={send}>
                Spara
              </div>
            </Col>
          </Row>

          <br />

          {drivers && drivers.length > 0 && (
            <Row>
              <Col xs={12}>
                <h3>Existerande chaufförer</h3>
                {drivers.map((d) => (
                  <div key={d._id}>{`${d.name} hos ${d.carrierName} till ${d.locks}`}</div>
                ))}
              </Col>
            </Row>
          )}
        </Grid>
      </Modal>
    </div>
  )
}

export default InviteCarrierModal
